/**
 * Main JavaScript Entry Point
 */
import { Navigation } from './modules/navigation.js';
import { ReservationForm } from './modules/reservation-form.js';

function track(eventName, parameters = {}) {
    if (typeof window.gtag !== 'function') {
        return;
    }

    window.gtag('event', eventName, parameters);
}

function getInternalDestination(link) {
    if (!link.href) {
        return '';
    }

    let destination;
    try {
        destination = new URL(link.href, window.location.href);
    } catch (error) {
        return '';
    }

    if (destination.origin !== window.location.origin || '/wp-admin' === destination.pathname.slice(0, 9)) {
        return '';
    }

    return `${destination.pathname}${destination.search}${destination.hash}`;
}

function getWhatsAppLocation(link) {
    const hostname = new URL(link.href, window.location.href).hostname;

    if (!['wa.me', 'api.whatsapp.com'].includes(hostname) && !link.matches('.btn-whatsapp, #btn-whatsapp-cta, .whatsapp-button, .whatsapp-sticky')) {
        return '';
    }

    if (link.matches('.whatsapp-sticky')) {
        return 'floating';
    }
    if (link.matches('.btn-whatsapp, #btn-whatsapp-cta')) {
        return 'hero';
    }
    return 'content';
}

function initializeAnalyticsTracking() {
    document.addEventListener('click', (event) => {
        const link = event.target.closest('a');
        if (!link) {
            return;
        }

        const whatsappLocation = getWhatsAppLocation(link);
        if (whatsappLocation) {
            track('whatsapp_click', { location: whatsappLocation });
            return;
        }

        let navigationType = '';
        if (link.closest('.primary-nav, .mobile-nav')) {
            navigationType = 'menu';
        } else if (link.closest('.posts-grid-card__image-wrap, .posts-grid-card__title, .posts-grid-card__button')) {
            navigationType = 'service';
        } else if (link.closest('.cta-group, .home-section__cta, .posts-grid__more-link')) {
            navigationType = 'cta';
        }

        if (!navigationType) {
            return;
        }

        const destination = getInternalDestination(link);
        if (destination) {
            track('navigation_click', { navigation_type: navigationType, destination });
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    // Initialize navigation
    new Navigation('.site-header');

    // Initialize reservation form (if present)
    new ReservationForm('#reservation-form');

    initializeAnalyticsTracking();

    // Floating Buttons Visibility (WhatsApp & Back to Top)
    const whatsappBtn = document.querySelector('.whatsapp-sticky');
    const backToTopBtn = document.querySelector('.back-to-top');

    if (whatsappBtn || backToTopBtn) {
        const toggleButtonsVisibility = () => {
            const isVisible = window.scrollY > 300;
            if (whatsappBtn) {
                whatsappBtn.classList.toggle('is-visible', isVisible);
            }
            if (backToTopBtn) {
                backToTopBtn.classList.toggle('is-visible', isVisible);
            }
        };

        window.addEventListener('scroll', toggleButtonsVisibility);
        toggleButtonsVisibility(); // Check on load
    }

    // Back to Top Click
    if (backToTopBtn) {
        backToTopBtn.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    }


    document.querySelectorAll('.schema-faq-section').forEach(s => { s.addEventListener('click', () => s.classList.toggle('is-open')); });

});
